// src/utils/exam.js  (ou safeExam.js)
export function generateExamCode(qcmId) {
  const idx1 = (qcmId * 23) % 26;
  const idx2 = (qcmId * 13) % 26;
  const char1 = String.fromCharCode(97 + idx1);
  const char2 = String.fromCharCode(97 + idx2);
  const num   = Math.round(qcmId / 2);
  return `${char1}${char2}${num}`;
}
